import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fbf106e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2fbf106e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf106e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbf106e')) {
      api.createRecord('2fbf106e', component.options)
    } else {
      api.reload('2fbf106e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fbf106e&scoped=true", function () {
      api.rerender('2fbf106e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/XrCreate/index.vue"
export default component.exports